
const state ={
    isPlaying: true,
    isPlaying2:true,
}

const getters = {}

const actions ={}

const mutations ={
    toggleMusicState (state,n) {
        let oAudio = document.querySelector(n);
        if(!state.isPlaying){
         oAudio.play();//开始播放  
         console.log('音乐开始-----');   
        }else{
         oAudio.pause();//暂停播放 
         console.log('音乐暂停-----'); 
        }
        state.isPlaying = !state.isPlaying
      },
      toggleMusicState2 (state,n) {
        let oAudio = document.querySelector(n);
        if(state.isPlaying2){
         oAudio.play();//开始播放  
         console.log('音乐开始2-----');   
        }else{
         oAudio.pause();//暂停播放 
         console.log('音乐暂停2-----'); 
        }
        // state.isPlaying2 = !state.isPlaying2
      }

}

export default {
    state,
    getters,
    actions,
    mutations
}



